prepareContext